/* Offre panier Source Sacrée — 15/08/2026.
 *
 * Ce fichier est charge par layout/theme.liquid (defer) sur TOUTES les pages.
 * Il ne doit PAS vivre dans un snippet du tiroir panier : le contenu du tiroir
 * n'est rendu que si le panier n'est pas vide, et les sections re-rendues par
 * morphing n'executent jamais leurs <script>. Une session qui commencait
 * panier vide n'avait donc AUCUN de ces comportements (boutons morts,
 * auto-ajout inerte) — bug constate en prod le 15/08.
 *
 * Contenu :
 *  - delegation de clic des boutons d'ajout upsell [data-ag-upsell-add]
 *  - ajout AUTOMATIQUE des cadeaux (bracelet surprise des 3 articles,
 *    ebook purification des 55 €) via custom elements — connectedCallback
 *    se declenche meme quand l'element arrive par morphing
 *  - retrait automatique des cadeaux quand leur palier n'est plus atteint
 *  - respect du refus : tout clic sur les controles de la ligne d'un cadeau
 *    pose un drapeau sessionStorage ; le cadeau retire volontairement n'est
 *    pas re-force, un bouton de rattrapage est devoile a la place
 *  - ouverture du tiroir depuis la redirection de /cart (?ag-cart=1) et
 *    depuis les liens « Voir mon panier » de la buybox des articles
 */
(function () {
  'use strict';
  if (window.agCartOfferInit) return;
  window.agCartOfferInit = true;

  var FLAGS = {
    surpriseOff: 'ag_surprise_off',
    ebookOff: 'ag_ebook_off',
    ebookAuto: 'ag_ebook_auto',
  };
  var SURPRISE_HANDLE = '/products/bracelet-surprise';
  var EBOOK_HANDLE = '/products/ebook-purification-rechargement-pierres';

  function flag(name) {
    try { return sessionStorage.getItem(name) === '1'; } catch (e) { return false; }
  }
  function setFlag(name, on) {
    try { on ? sessionStorage.setItem(name, '1') : sessionStorage.removeItem(name); } catch (e) {}
  }

  async function dispatchCart(sourceId) {
    var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: sourceId, data: { source: sourceId, itemCount: cart.item_count } },
      })
    );
  }

  function cartAdd(variantId, sourceId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return dispatchCart(sourceId);
    });
  }

  function cartRemove(lineKey, sourceId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    }).then(function (r) { return r.json(); }).then(function () {
      return dispatchCart(sourceId);
    });
  }

  /* --- Boutons d'ajout (upsell payant + rattrapage cadeaux) --------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ag-upsell-add]');
    if (!btn || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    var textEl = btn.querySelector('.ag-tup__btn-text');
    var original = textEl ? textEl.textContent : '';
    btn.classList.add('is-loading');
    if (textEl) textEl.textContent = '…';
    /* Un rattrapage cadeau clique = le client le reveut : lever son refus. */
    if (btn.hasAttribute('data-ag-clear-surprise-off')) setFlag(FLAGS.surpriseOff, false);
    if (btn.hasAttribute('data-ag-clear-ebook-off')) setFlag(FLAGS.ebookOff, false);
    cartAdd(btn.getAttribute('data-variant-id'), 'ag-upsell')
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (textEl) textEl.textContent = 'Ajouté ✓';
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (textEl) textEl.textContent = original;
        console.error('ag-cart-offer: ajout impossible', err);
      });
  });

  /* --- Refus d'un cadeau : clic sur les controles de sa ligne panier ------ */
  document.addEventListener('click', function (e) {
    var control = e.target.closest && e.target.closest('button');
    if (!control) return;
    var row = control.closest && control.closest('.cart-items__table-row');
    if (!row) return;
    if (row.querySelector('a[href*="' + SURPRISE_HANDLE + '"]')) setFlag(FLAGS.surpriseOff, true);
    if (row.querySelector('a[href*="' + EBOOK_HANDLE + '"]')) setFlag(FLAGS.ebookOff, true);
  });

  /* --- Suggestions du tiroir (ag-cart-recommendations) -------------------- */
  /* Délégation : le bloc arrive par morphing, ses propres scripts ne
     s'exécuteraient pas (19/10/2026). */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest && e.target.closest('[data-ag-reco-nav]');
    if (nav) {
      var zone = nav.closest('.ag-reco') && nav.closest('.ag-reco').querySelector('[data-ag-reco-scroll]');
      if (zone) zone.scrollBy({ left: 272 * Number(nav.getAttribute('data-ag-reco-nav')), behavior: 'smooth' });
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-ag-reco-add]');
    if (!btn || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    var texte = btn.querySelector('.ag-reco__add-text');
    var avant = texte ? texte.textContent : '';
    btn.classList.add('is-loading');
    if (texte) texte.textContent = '…';
    cartAdd(btn.getAttribute('data-variant-id'), 'ag-cart-recommendations')
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (texte) texte.textContent = 'Ajouté ✓';
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (texte) texte.textContent = avant;
      });
  });

  /* --- Liens « Voir mon panier » : ouvrir le tiroir sur place ------------- */
  document.addEventListener('click', function (e) {
    var lien = e.target.closest && e.target.closest('[data-ag-buybox-follow]');
    if (!lien) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      e.preventDefault();
      drawer.open();
    }
  });

  /* --- Arrivee depuis la redirection de /cart ----------------------------- */
  if (window.location.search.indexOf('ag-cart=1') !== -1) {
    window.addEventListener('load', function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('ag-cart');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (e) {}
    });
  }

  /* --- Custom elements : ajout/retrait automatique des cadeaux ------------ */
  /* L'element est rendu par ag-cart-threshold-upsell.liquid uniquement quand
     sa condition est vraie ; connectedCallback = la condition VIENT d'etre
     constatee dans un rendu frais (chargement ou morph). */

  function defineAutoAdd(tag, offFlag, sourceId, cadeauHandle, extra) {
    if (window.customElements.get(tag)) return;
    window.customElements.define(tag, class extends HTMLElement {
      connectedCallback() {
        var el = this;
        var variantId = el.getAttribute('data-variant-id');
        if (!variantId) return;
        var bloc = el.closest('.ag-tup');
        if (flag(offFlag)) {
          /* Refus : pas de re-forcage, on devoile le bouton de rattrapage. */
          if (bloc) {
            var fallback = bloc.querySelector('[data-ag-fallback]');
            var auto = bloc.querySelector('[data-ag-auto-state]');
            if (fallback) fallback.removeAttribute('hidden');
            if (auto) auto.setAttribute('hidden', '');
          }
          return;
        }
        var lock = 'agAdding_' + tag;
        if (window[lock]) return;
        window[lock] = true;
        /* Verite serveur avant d'ajouter : deux re-renders rapproches peuvent
           tous deux presenter le cadeau comme absent (le HTML d'un morph peut
           etre calcule avant que l'ajout precedent soit visible) — sans ce
           controle, le cadeau partait en double (constate le 15/08). */
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var deja = cart.items.some(function (i) { return i.handle === cadeauHandle; });
            if (deja) { window[lock] = false; return null; }
            return cartAdd(variantId, sourceId).then(function () {
              window[lock] = false;
              if (extra) extra();
            });
          })
          .catch(function () { window[lock] = false; });
      }
    });
  }

  defineAutoAdd('ag-surprise-auto-add', FLAGS.surpriseOff, 'ag-surprise-auto-add', 'bracelet-surprise', null);
  defineAutoAdd('ag-gift-auto-add', FLAGS.ebookOff, 'ag-gift-auto-add', 'ebook-purification-rechargement-pierres', function () {
    /* Marque « ajoute par nous » : seul un ebook auto-ajoute peut etre
       auto-retire si le total redescend (un achat volontaire, jamais). */
    setFlag(FLAGS.ebookAuto, true);
  });

  function defineGuard(tag, sourceId, opts) {
    if (window.customElements.get(tag)) return;
    window.customElements.define(tag, class extends HTMLElement {
      connectedCallback() {
        var key = this.getAttribute('data-line-key');
        if (!key) return;
        if (opts && opts.onlyIfFlag && !flag(opts.onlyIfFlag)) return;
        var lock = 'agRemoving_' + tag;
        if (window[lock]) return;
        window[lock] = true;
        if (opts && opts.clearFlags) opts.clearFlags.forEach(function (f) { setFlag(f, false); });
        cartRemove(key, sourceId)
          .then(function () { window[lock] = false; })
          .catch(function () { window[lock] = false; });
      }
    });
  }

  /* Surprise : palier < 3 -> retrait, et on repart de zero (le cadeau
     reviendra tout seul si le panier repasse a 3). */
  defineGuard('ag-surprise-guard', 'ag-surprise-guard', { clearFlags: [FLAGS.surpriseOff] });
  /* Ebook : total (hors ebook) < 55 € -> retrait UNIQUEMENT s'il avait ete
     auto-ajoute. */
  defineGuard('ag-gift-guard', 'ag-gift-guard', { onlyIfFlag: FLAGS.ebookAuto, clearFlags: [FLAGS.ebookAuto] });
})();
